import { render, staticRenderFns } from "./GradeGrid.vue?vue&type=template&id=2bcab360"
import script from "./GradeGrid.vue?vue&type=script&lang=js"
export * from "./GradeGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports